import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

// import './plugins/element-ui'
import './plugins/filter'
import './plugins/components'

import Print from './plugins/print'

import './assets/stylus/common.styl'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
Vue.use(ElementUI, { size: 'small', zIndex: 3000 })

Vue.use(Print)
Vue.config.productionTip = false

// console.log(111111111111, process.env.VUE_APP_BUILD_MODE, store.state.account.userInfo)
if (process.env.VUE_APP_BUILD_MODE === 'FHZ_WEB') {
  if (self !== top) {
    window.parent.postMessage({ type: 'get_user_info' }, '*')
    window.addEventListener('message', (e) => {
      if (e.data.type === 'send_user_info') {
        console.log(22222222222222222222, e)
        localStorage.setItem('zs.userInfo', JSON.stringify(e.data.data))
        /* eslint-disable no-new */
        new Vue({
          router,
          store,
          render: h => h(App)
        }).$mount('#app')
      }
    }, false)
  }
} else {
  /* eslint-disable no-new */
  new Vue({
    router,
    store,
    render: h => h(App)
  }).$mount('#app')
}
